export default __webpack_public_path__ + "static/banner_image-eaef7e41dc4c322e7c98057929e31b86.jpg";